import { render, staticRenderFns } from "./SampleList.vue?vue&type=template&id=32817242&scoped=true"
import script from "./SampleList.vue?vue&type=script&lang=ts"
export * from "./SampleList.vue?vue&type=script&lang=ts"
import style0 from "./SampleList.vue?vue&type=style&index=0&id=32817242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32817242",
  null
  
)

export default component.exports